import { render, staticRenderFns } from "./officeContact.vue?vue&type=template&id=4f8239c3&"
import script from "./officeContact.vue?vue&type=script&lang=js&"
export * from "./officeContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports